import { useState } from 'react';
import { ChevronDown, ChevronUp, Paperclip } from 'lucide-react';
import type { EmailContext } from '../hooks/useEmailContext';

interface Props {
  email: EmailContext;
}

export function EmailPreview({ email }: Props) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="email-preview">
      <button className="email-header" onClick={() => setExpanded(e => !e)}>
        <div className="email-meta">
          <span className="email-subject">{email.subject || '(Sin asunto)'}</span>
          <span className="email-sender">{email.sender} &lt;{email.senderEmail}&gt;</span>
        </div>
        {expanded ? <ChevronUp size={14} className="chevron" /> : <ChevronDown size={14} className="chevron" />}
      </button>
      {email.attachments.length > 0 && (
        <div className="email-attachments">
          {email.attachments.map(a => (
            <span key={a.id} className="attached-chip" title={`${(a.size / 1024).toFixed(1)} KB — se incluirá como contexto`}>
              <Paperclip size={11} /> {a.name}
            </span>
          ))}
        </div>
      )}
      {expanded && (
        <div className="email-body">
          <pre>{email.body.slice(0, 800)}{email.body.length > 800 ? '…' : ''}</pre>
        </div>
      )}
    </div>
  );
}
